import React, { useState } from "react";
import axios from "axios";
import { API } from "../App";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import { Mail, Send, CheckCircle } from "lucide-react";

const NewsletterSection = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error("Please enter your email address");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/newsletter/subscribe`, {
        email,
        name: name || null
      });
      
      if (response.data.status === "existing") {
        toast.info("You're already subscribed!");
      } else {
        toast.success("Successfully subscribed to our newsletter!");
      }
      setSubscribed(true);
      setEmail("");
      setName("");
    } catch (error) {
      toast.error("Failed to subscribe. Please try again.");
      console.error("Newsletter error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (subscribed) {
    return (
      <section className="py-12 bg-secondary-50">
        <div className="container-custom">
          <div className="max-w-2xl mx-auto text-center">
            <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-8 h-8 text-green-600" />
            </div>
            <h3 className="font-heading text-xl font-semibold text-gray-900 mb-2">
              Thank You for Subscribing!
            </h3>
            <p className="text-gray-600">
              You'll receive updates about our activities and events.
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-12 bg-secondary-50">
      <div className="container-custom">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-14 h-14 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-4">
            <Mail className="w-7 h-7 text-secondary-700" />
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-gray-900 mb-3">
            Stay Connected
          </h2>
          <p className="text-gray-600 mb-8">
            Subscribe to our newsletter to receive updates about our activities, events, and community news.
          </p>
          
          <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
            <Input
              type="text"
              placeholder="Your name (optional)"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="flex-grow bg-white"
              data-testid="newsletter-name"
            />
            <Input
              type="email"
              placeholder="Your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-grow bg-white"
              required
              data-testid="newsletter-email"
            />
            <Button 
              type="submit" 
              className="btn-secondary whitespace-nowrap"
              disabled={loading}
              data-testid="newsletter-subscribe"
            >
              {loading ? (
                "Subscribing..."
              ) : (
                <>
                  <Send className="w-4 h-4 mr-2" />
                  Subscribe
                </>
              )}
            </Button>
          </form>
          
          <p className="text-xs text-gray-500 mt-4">
            We respect your privacy. Unsubscribe at any time.
          </p>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
